import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "CakePHP is a mature, MVC-based PHP framework built around convention over configuration. Sensible defaults, built-in ORM and scaffolding let us stand up working applications quickly without sacrificing structure.",
    "It ships with security features — input validation, CSRF and SQL-injection protection — baked in, which makes it a dependable choice for business applications that handle real data.",
];

const FEATURES = [
    { title: "Convention over configuration", text: "Sensible defaults mean less setup and more time spent on your actual features." },
    { title: "Built-in ORM", text: "A clean data layer makes working with your database fast, readable and safe." },
    { title: "Security by default", text: "Validation, CSRF and injection protection are part of the framework, not an afterthought." },
    { title: "Rapid scaffolding", text: "Generate CRUD and boilerplate instantly, then refine — ideal for tight timelines." },
];

const CHECKS = [
    "Custom web applications",
    "Business & admin systems",
    "RESTful APIs",
    "Legacy app modernisation",
    "Ongoing maintenance & support",
];

export default function Cakephp() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Web Development" title="CakePHP Development" eyebrowAs="span">
                    Rapid, convention-driven PHP applications built on CakePHP — secure, well-structured and quick to ship.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
